import { render, staticRenderFns } from "./x-tag-cloud.vue?vue&type=template&id=774d0a9a&scoped=true&"
import script from "./x-tag-cloud.vue?vue&type=script&lang=js&"
export * from "./x-tag-cloud.vue?vue&type=script&lang=js&"
import style0 from "./x-tag-cloud.vue?vue&type=style&index=0&id=774d0a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d0a9a",
  null
  
)

export default component.exports